var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoute(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8026_8718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.58317 4.16602H9.94517C12.4845 4.16602 13.7542 4.16602 14.2362 4.62209C14.6528 5.01632 14.8375 5.59708 14.725 6.15952C14.5948 6.8102 13.5583 7.54339 11.4851 9.00979L8.09794 11.4056C6.02476 12.872 4.98816 13.6052 4.85803 14.2558C4.74555 14.8183 4.93018 15.399 5.34681 15.7933C5.82878 16.2493 7.09847 16.2493 9.63784 16.2493H10.4165M6.6665 4.16602C6.6665 5.54673 5.54722 6.66602 4.1665 6.66602C2.78579 6.66602 1.6665 5.54673 1.6665 4.16602C1.6665 2.7853 2.78579 1.66602 4.1665 1.66602C5.54722 1.66602 6.6665 2.7853 6.6665 4.16602ZM18.3332 15.8327C18.3332 17.2134 17.2139 18.3327 15.8332 18.3327C14.4525 18.3327 13.3332 17.2134 13.3332 15.8327C13.3332 14.452 14.4525 13.3327 15.8332 13.3327C17.2139 13.3327 18.3332 14.452 18.3332 15.8327Z",
    stroke: "#0077C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8026_8718"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoute);
export default __webpack_public_path__ + "static/media/Route.f59c3900413f0d3c7c8eab1470e64f1c.svg";
export { ForwardRef as ReactComponent };